import { render } from "./item-card.vue?vue&type=template&id=7ba27db7"
import script from "./item-card.vue?vue&type=script&lang=js"
export * from "./item-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__